import styled from 'styled-components';

export const TitleBig = styled.h2`
    color: ${ props => props.theme.primaryColor };
    display: flex;
    font-size: 16px;
    font-weight: ${ ({ theme }) => theme.fontWeightMedium };
    margin: 0 5px 0 0;
    padding: 0;
    text-transform: capitalize;

    @media(max-width: ${ ({ theme }) => theme.tabletBreakpoint }) {
        font-size: 13px;
    }
`;

export const Title = styled.h3`
    color: ${ props => props.theme.greyColor };
    font-size: 13px;
    font-weight: ${ ({ theme }) => theme.fontWeightRegular };
    letter-spacing: 1px;
    margin: 0 0 5px;
    text-transform: capitalize;
`;

export const TitleHuge = styled.h1`
    color: ${ props => props.theme.primaryColor };
    font-size: 24px;
    font-weight: ${ ({ theme }) => theme.fontWeightMedium };
    margin: 0;
    padding: 0;
    text-align: center;

    @media(max-width: ${ ({ theme }) => theme.tabletBreakpoint }) {
        font-size: 18px;
    }
`;

export const TitleMedium = styled(TitleBig)`
    font-weight: ${ ({ theme }) => theme.fontWeightRegular };
`;
